import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmDialog({ open, onOpenChange, title, description, onConfirm, confirmText = 'Delete', confirmVariant = 'danger' }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="confirm-dialog">
        <DialogHeader>
          <div className="confirm-dialog-icon">
            <AlertTriangle size={48} />
          </div>
          <DialogTitle className="confirm-dialog-title">{title}</DialogTitle>
          <DialogDescription className="confirm-dialog-description">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="confirm-dialog-actions">
          <Button 
            onClick={() => onOpenChange(false)} 
            className="btn-secondary"
          >
            Cancel
          </Button>
          <Button 
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className={confirmVariant === 'danger' ? 'btn-danger' : 'btn-primary'}
          >
            {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}